<template>
    <div class="pb-4">
        <div>
            <h3 style="font-weight: 700;">Hiển thị cột</h3>
            <el-checkbox :indeterminate="isIndeterminate" size="medium" class="mb-2" v-model="checkAll" @change="handleCheckAllChange">Chọn tất cả</el-checkbox>
        </div>
        <el-row :gutter="20">
            <el-checkbox-group size="medium" v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-col :span="6" class="my-2 fa-2x" v-for="(item, index) in columnLabels" :key="index">
                    <el-checkbox v-if="item.key !== 'branch_id' || isGDKV"  :span="6"  :label="item" :key="item">{{item}}</el-checkbox>
                </el-col>
            </el-checkbox-group>
        </el-row>
        <div class="d-flex justify-content-end">
            <el-button @click="saveConfig()" :loading="loadingSave">{{ isUpdate ? 'Sửa thông tin' : 'Lưu thông tin' }}</el-button>
        </div>
    </div>
</template>

<script>

import {SERVICE_CONFIG_CUSTOMER_STORE} from "@/core/services/store/service.module";

export default {
    name: "FilterTable",
    props: {
        tableColumnLabels: {
            type: Object,
        },

        isUpdate: {
            type: Boolean,
        }
    },
    data() {
        return {
            checkAll: false,
            checkedCities: [],
            isIndeterminate: true,
            loadingSave: false,
            columnLabels: {
                name: 'Họ và tên',
                ngay_sinh: 'Năm sinh',
                phone: 'Số điện thoại',
                object_customer: 'Đối tượng',
                total_input_amount: 'Số tiền nhập',
                co_quan: 'Trường học',
                nguon: 'Kênh khách hàng',
                hot_key: 'Phím nóng',
                level: 'Level',
                ngay_hen: 'Lịch hẹn',
                trung_tam_hen: 'Trung tâm hẹn',
                chi_nhanh_hen: 'Chi nhánh hẹn',
                tu_van_vien: 'Người tư vấn',
                muc_tieu: 'Mục tiêu',
                trang_thai_tu_van: 'Trạng thái tư vấn',
                ma_gioi_thieu: 'Mã/Người giới thiệu',
                hanh_dong: 'Hành động',
            }
        };
    },
    mounted() {
        Object.keys(this.columnLabels).forEach(key => {
            if (this.tableColumnLabels[key] === true) {
                this.checkedCities.push(this.columnLabels[key]);
            }
        });
    },
    methods: {
        acceptAll() {
            return Object.values(this.columnLabels);
        },
        handleCheckAllChange(val) {
            this.isIndeterminate = false;
            this.checkedCities = val ? this.acceptAll() : [];
            Object.keys(this.tableColumnLabels).forEach(key => {
                if (key !== 'name') {
                    this.tableColumnLabels[key] = !!val;
                }
            });
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === Object.keys(this.columnLabels).length;
            this.isIndeterminate = checkedCount > 0 && checkedCount <  Object.keys(this.columnLabels).length;
            const removedItems = Object.values(this.columnLabels).filter(item => !value.includes(item));
            const addedItems = value.filter(item => !Object.values(this.columnLabels).includes(item.key));
            removedItems.forEach(item => {
                const foundKey = Object.keys(this.columnLabels).find(key => this.columnLabels[key] === item);
                let accept = false;
                this.tableColumnLabels[foundKey] = accept;
            });
            addedItems.forEach(item => {
                const foundKey = Object.keys(this.columnLabels).find(key => this.columnLabels[key] === item);
                this.tableColumnLabels[foundKey] = true;
            });
        },
        saveConfig() {
            this.loadingSave = true;
            let data = this.tableColumnLabels
            this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_STORE, {  detail: data, config_type: 3, model: 'customer'})
                .then(() => {
                    this.isUpdate = true;
                    this.loadingSave = false;
                    this.$message.success('Lưu cấu hình thành công');
                })
        }
    }
};
</script>

<style scoped>
.el-col {
    font-weight: 500;
}
</style>
